import { LogoWrapper, LogoImage, LogoName } from "./styles";

export const SPOTDEAL_LOGO_SRC = "/img/spotdeal-logo.jpg";

interface SpotDealLogoProps {
  size?: number;
  showName?: boolean;
  nameSize?: "sm" | "md" | "lg";
  rounded?: number;
  inline?: boolean;
  gap?: number;
  className?: string;
}

const SpotDealLogo = ({
  size = 48,
  showName = false,
  nameSize = "md",
  rounded,
  inline = true,
  gap = 12,
  className,
}: SpotDealLogoProps) => {
  const radius = rounded ?? Math.round(size * 0.22);

  return (
    <LogoWrapper
      className={className}
      $gap={gap}
      $inline={inline}
      aria-label="Spot Deal"
    >
      <LogoImage
        src={SPOTDEAL_LOGO_SRC}
        alt="Spot Deal logo"
        $size={size}
        $rounded={radius}
        loading="lazy"
      />
      {showName && <LogoName $size={nameSize}>Spot Deal</LogoName>}
    </LogoWrapper>
  );
};

export default SpotDealLogo;
